import { render, staticRenderFns } from "./FormPWR3.vue?vue&type=template&id=e56a5c4e&scoped=true"
import script from "./FormPWR3.vue?vue&type=script&lang=js"
export * from "./FormPWR3.vue?vue&type=script&lang=js"
import style0 from "./FormPWR3.vue?vue&type=style&index=0&id=e56a5c4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56a5c4e",
  null
  
)

export default component.exports